module.exports = "pegasus_template/assets/themecapture1/product/106.png";